<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-steps :active="2" align-center style="border-bottom:1px solid #E9E9E9;padding-bottom:20px;">
        <el-step title="准备充电" :description="rowdata.startTime" />
        <el-step title="开始充电" :description="rowdata.startTime" />
        <el-step title="结束充电" :description="rowdata.endTime" />
        <el-step title="订单支付" :description="rowdata.payTime" />
      </el-steps>
      <div class="orderInfo">
        <div class="orderMoney">
          <div>订单总金额</div>
          <span class="money">{{ getFloat(rowdata.totalMoney) }}</span>
          <span class="col-333">元</span>
        </div>
        <div class="orderMoney">
          <div>订单总优惠</div>
          <span class="money">{{ getFloat(rowdata.discountMoney) }}</span>
          <span class="col-333">元</span>
        </div>
        <div class="orderMoney">
          <div>实收金额</div>
          <span class="money">{{ getFixed2(rowdata.totalMoneyActual) }}</span>
          <span class="col-333">元</span>
        </div>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm ref="formref" :fields="formfields" :data-form="rowdata" label-width="120px" form-style="width:30%" label-position="left" :is-show-btn="false" />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电信息</span>
      </div>
      <div style="padding-left: 5%;display: flex;">
        <div style="width: 30%;margin-right:10px;">
          <div>充电总时长 &nbsp;&nbsp;{{ rowdata.totalTime }}</div>
        </div>
        <div style="width: 30%;margin-right:10px;">
          <div>充电总电量（度） &nbsp;&nbsp;{{ getFloat(rowdata.totalPower) }}</div>
        </div>
        <div style="width: 30%;margin-right:10px;">
          <div>订单总金额（元） &nbsp;&nbsp;{{ getFloat(rowdata.totalMoney) }}</div>
        </div>
      </div>
    </el-card>
    <!-- <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
        <span style="font-weight:600;color:#000; line-height: 10px;">电站活动抵扣</span>
    </div>
    <div style="padding-top: 20px; padding-bottom: 20px; display: flex; flex-direction: row; justify-content: center;">
      <div style="width: 33%; ">
        <div>抵扣电费</div>
        <div>2.05元</div>
      </div>
      <div style="width: 33%; text-align: center;">
        <div>抵扣服务费</div>
        <div>2.05元</div>
      </div>
      <div style="width: 33%; text-align: right;">
        <div>抵扣总费用</div>
        <div>2.05元</div>
      </div>
    </div> -->
    <!-- <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
        <span style="font-weight:600;color:#000; line-height: 10px;">优惠抵扣</span>
    </div>
    <div style="padding-top: 20px; padding-bottom: 20px; display: flex; flex-direction: row; justify-content: center;">
      <div style="width: 33%; ">
        <div>抵扣电费</div>
        <div>{{getFloat(rowdata.discountElecFee)}}元</div>
      </div>
      <div style="width: 33%; text-align: center;">
        <div>抵扣服务费</div>
        <div>{{getFloat(rowdata.discountServiceFee)}}元</div>
      </div>
      <div style="width: 33%; text-align: right;">
        <div>抵扣总费用</div>
        <div>{{getFloat(rowdata.discountElecFee + rowdata.discountServiceFee)}}元</div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Daichulidingdanxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: '充电单号',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          type: 'div',
          style: 'width:100%',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          type: 'div',
          style: 'width:100%',
          prop: 'userName'
        },
        {
          label: '充电卡号',
          type: 'div',
          style: 'width:100%',
          prop: 'cardNum'
        },
        {
          label: '充电车辆',
          type: 'div',
          style: 'width:100%',
          prop: 'plateNumber'
        },
        {
          label: '车辆VIN码',
          type: 'div',
          prop: 'VINCode'
        },
        {
          label: '归属企业',
          type: 'div',
          style: 'width:100%',
          prop: 'belongOrg'
        },
        // {
        //     label: "充电VIN码",
        //     type: "div",
        //     prop: "VINCode",
        // },
        {
          label: '运营商流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'outStartChargeSeq'
        },
        {
          label: '流量方流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'hlhtStartChargeSeq'
        },
        // {
        //     label: "订单类型",
        //     type: "div",
        //     prop: "orderType",
        // },
        // {
        //     label: "充电模式",
        //     type: "div",
        //     prop: "chargingType",
        // },
        {
          label: '终端名称',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorName'
        },
        {
          label: '电桩品牌',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentBrand'
        },
        {
          label: '电桩型号',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentModel'
        },
        {
          label: '电桩功率',
          type: 'div',
          style: 'width:100%',
          prop: 'equipPower'
        },
        {
          label: '电站名称',
          type: 'div',
          style: 'width:100%',
          prop: 'stationName'
        },
        {
          label: '运营商',
          type: 'div',
          style: 'width:100%',
          prop: 'orgName'
        },
        {
          label: '运营商属性',
          type: 'div',
          style: 'width:100%',
          prop: 'attrValue'
        }
      ],
      id: ''
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeMount() {
    this.id = this.$route.query.data
  },
  methods: {
    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/getPendingOrderDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          if (resp.connectorPower > 0) {
            this.rowdata.connectorPower = this.rowdata.connectorPower + 'KW'
          }
        }
      })
    },

    cancel() {
      this.$router.go(-1)
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .orderInfo{
    width:100%;
    height:110px;
    display: flex;
    flex-direction: row;
    align-items:center;
    border-bottom:1px solid #E9E9E9;
    padding-left: 6%;
    .orderMoney{
      width: 300px;
      color:#999999;
      font-size:12px;
      .money{
        color:#1890FF;
        font-size:36px;
      }
    }
  }
  .col-333{
    color:#333333;
  }

</style>



// WEBPACK FOOTER //
// src/views/orderManagement/pendingDetail.vue